import React from 'react';
import { Box, RoutedButton, Text } from 'grommet';
import { getAppName } from '../utils';

const PageHeader = ({title, link, ...props}) => {
    return (
        <Box pad="12px" background="dark-2" direction="row" {...props} >
            <Box flex="grow">
                <RoutedButton plain={true} path="/">
                    <Text weight="bold">{getAppName()}</Text>
                </RoutedButton>
            </Box>
            <Box>
                <RoutedButton plain={true} path="/autor">
                    <Text>Autorský kolektiv</Text>
                </RoutedButton>
            </Box>
        </Box>
    );
};

export default PageHeader;
